import {cache0} from "../../utils/cache0";

export const isMac = cache0(() => /Mac/i.test(navigator.platform));